module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Trash-1cbb15e61e3389bf4ea81e115e2b4821.svg";